
import { defineComponent } from 'vue'
import { meeting_title } from '@/utils/constant'
import { useRoute, useRouter } from 'vue-router'
import type { Router, RouteLocationNormalizedLoaded } from 'vue-router'

export default defineComponent({
  setup() {
    const router: Router = useRouter()
    const route: RouteLocationNormalizedLoaded = useRoute()
    const handelGoHome = () => {
      if (route.name !== 'home') {
        router.push({
          name: 'home'
        })
      }
    }
    const handleGoMeeting = () => {
      // if (route.name !== 'meeting') {
      //   router.push({
      //     name: 'meeting'
      //   })
      // }
    }
    return {
      meeting_title,
      handelGoHome,
      handleGoMeeting
    }
  }
})
